import React from'react';export var DeviceTypeContext=React.createContext('mobile');